<!--
@Author: OuyangQiangqiang
@Date: 2018-06-09
@Description: 这是一个用在el-card标签中的组件 bd-card-title

属性：
1.text：标题文字
2.btn-text：右侧按钮文字
3.btn-type：按钮的类型

用例：
<el-card>
  <bd-card-title text="车贷申请详情" btn-text="返回" btn-type="primary" @click="syso"></bd-card-title>
</el-card>

-->
<template>
  <div>
    <span style="font-weight: bold">{{text}}</span>
    <el-button style="float: right; padding: 12px 20px; margin-top: -8px;" v-bind:type="btnType" v-on:click="$emit('click')"><i :class="btnClass"></i></el-button>
  </div>
</template>

<script>
export default {
  name: 'bd-card-title',
  props: {
    text: {
      type: String,
      required: true
    },
    btnClass: {
      type: String
    },
    btnType: {
      type: String,
      default: 'text'
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/appinfo/bdCardTitle.vue